export function FlowSection() {
  const flows = [
    {
      icon: 'ri-book-open-line',
      title: '授業',
      description: '個別指導または少人数指導で、一人ひとりに合わせた授業を実施。わからないところは何度でも質問できます。',
      color: 'bg-blue-500'
    },
    {
      icon: 'ri-pencil-line',
      title: '宿題',
      description: '授業内容の定着を図る適切な量の宿題を出します。次回授業で必ずチェックし、理解度を確認します。',
      color: 'bg-green-500'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '小テスト',
      description: '前回の内容を小テストで確認。できるまで繰り返し、確実に定着させます。',
      color: 'bg-orange-500'
    },
    {
      icon: 'ri-door-open-line',
      title: '自習サポート',
      description: '授業がない日も自習室を利用可能。わからない問題は講師に質問できます。',
      color: 'bg-purple-500'
    },
    {
      icon: 'ri-chat-3-line',
      title: '面談',
      description: '定期的に保護者面談を実施。学習状況や今後の方針を共有し、ご家庭と連携します。',
      color: 'bg-pink-500'
    }
  ];

  const courses = [
    {
      name: 'スタディコース',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/6225996758aeec267422d5742c920c8b.jpeg',
      target: '小学生・中学生・高校生',
      style: '少人数指導',
      subjects: '英数理社国',
      features: [
        '基礎から応用まで幅広く対応',
        '定期テスト対策も万全',
        '学習習慣の定着をサポート'
      ]
    },
    {
      name: '数学強化コース',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/da10e06bfba82bacdb88594d087b0bb9.jpeg',
      target: '中学生',
      style: '集団指導',
      subjects: '数学専門',
      features: [
        '数学に特化した徹底指導',
        '苦手分野の克服',
        '応用問題への対応力を養成'
      ]
    },
    {
      name: 'サポートコース',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/6225996758aeec267422d5742c920c8b.jpeg',
      target: '小学生・中学生・高校生',
      style: '自学自習スタイル',
      subjects: '全教科対応',
      features: [
        '自分で教材を持参',
        '宿題や授業の質問対応',
        '気軽に利用できる'
      ]
    },
    {
      name: '完全個別コース',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/1cb7cfca047af27e1f9c6a22744e553c.jpeg',
      target: '小学生・中学生・高校生',
      style: '完全個別指導',
      subjects: '全教科対応',
      features: [
        '一人ひとりに完全カスタマイズ',
        '受験対策も徹底サポート',
        '最短で成績アップを実現'
      ]
    }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            授業の流れ
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            廿日市市の個別指導で、確実に成績を上げる学習サイクル
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {flows.map((flow, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all"
            >
              <div className={`w-14 h-14 flex items-center justify-center ${flow.color} rounded-xl mb-4 shadow-md`}>
                <i className={`${flow.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                {flow.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {flow.description}
              </p>
            </div>
          ))}
        </div>

        {/* コース紹介 */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
              コース紹介
            </h2>
            <p className="text-sm md:text-base text-gray-600">
              あなたに最適なコースをお選びください
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {courses.map((course, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
                <div className="w-full h-48 overflow-hidden">
                  <img 
                    src={course.image} 
                    alt={course.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">
                    {course.name}
                  </h3>
                  <div className="space-y-3 mb-4">
                    <div className="flex items-start">
                      <i className="ri-user-line text-teal-600 text-lg mr-2 mt-1"></i>
                      <div>
                        <p className="text-xs text-gray-500">対象</p>
                        <p className="text-sm font-semibold text-gray-800">{course.target}</p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <i className="ri-group-line text-teal-600 text-lg mr-2 mt-1"></i>
                      <div>
                        <p className="text-xs text-gray-500">指導形式</p>
                        <p className="text-sm font-semibold text-gray-800">{course.style}</p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <i className="ri-book-2-line text-teal-600 text-lg mr-2 mt-1"></i>
                      <div>
                        <p className="text-xs text-gray-500">対応科目</p>
                        <p className="text-sm font-semibold text-gray-800">{course.subjects}</p>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-4">
                    <p className="text-xs text-gray-500 mb-2">特徴</p>
                    <ul className="space-y-2">
                      {course.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start text-sm text-gray-700">
                          <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* コース案内テーブル（デスクトップ） */}
        <div className="hidden md:block mb-16">
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-black text-gray-800 mb-3">
              コース案内
            </h3>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-teal-600 text-white">
                    <th className="py-4 px-6 text-left text-sm font-bold">コース名</th>
                    <th className="py-4 px-6 text-left text-sm font-bold">対象</th>
                    <th className="py-4 px-6 text-left text-sm font-bold">指導形式</th>
                    <th className="py-4 px-6 text-left text-sm font-bold">対応科目</th>
                    <th className="py-4 px-6 text-left text-sm font-bold">月謝（税込）</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b hover:bg-gray-50 transition-colors">
                    <td className="py-4 px-6 font-bold text-gray-800">数学強化コース</td>
                    <td className="py-4 px-6 text-sm text-gray-700">中学生</td>
                    <td className="py-4 px-6 text-sm text-gray-700">少人数指導</td>
                    <td className="py-4 px-6 text-sm text-gray-700">数学専門</td>
                    <td className="py-4 px-6 text-sm font-semibold text-teal-600">月額1コマ ¥8,000</td>
                  </tr>
                  <tr className="border-b hover:bg-gray-50 transition-colors">
                    <td className="py-4 px-6 font-bold text-gray-800">スタディコース</td>
                    <td className="py-4 px-6 text-sm text-gray-700">学年問わず</td>
                    <td className="py-4 px-6 text-sm text-gray-700">少人数個別指導</td>
                    <td className="py-4 px-6 text-sm text-gray-700">どの教科でも</td>
                    <td className="py-4 px-6 text-sm font-semibold text-teal-600">月額1コマ ¥8,000</td>
                  </tr>
                  <tr className="border-b hover:bg-gray-50 transition-colors">
                    <td className="py-4 px-6 font-bold text-gray-800">サポートコース</td>
                    <td className="py-4 px-6 text-sm text-gray-700">学年問わず</td>
                    <td className="py-4 px-6 text-sm text-gray-700">自学自習スタイル</td>
                    <td className="py-4 px-6 text-sm text-gray-700">全教科対応</td>
                    <td className="py-4 px-6 text-sm font-semibold text-teal-600">1回 ¥500</td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="py-4 px-6 font-bold text-gray-800">完全個別指導コース</td>
                    <td className="py-4 px-6 text-sm text-gray-700">学年問わず</td>
                    <td className="py-4 px-6 text-sm text-gray-700">完全個別指導</td>
                    <td className="py-4 px-6 text-sm text-gray-700">全教科対応</td>
                    <td className="py-4 px-6 text-sm font-semibold text-teal-600">1回 ¥6,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="bg-gray-50 p-4 text-center">
              <p className="text-xs text-gray-600">
                ※入会金：¥10,000（税込）
              </p>
            </div>
          </div>
        </div>

        {/* コース案内カード（モバイル） */}
        <div className="md:hidden mb-16">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-black text-gray-800 mb-3">
              コース案内
            </h3>
          </div>

          <div className="space-y-4">
            {[
              { name: '数学強化コース', target: '中学生', style: '少人数指導', subjects: '数学専門', price: '月額1コマ ¥8,000' },
              { name: 'スタディコース', target: '学年問わず', style: '少人数個別指導', subjects: 'どの教科でも', price: '月額1コマ ¥8,000' },
              { name: 'サポートコース', target: '学年問わず', style: '自学自習スタイル', subjects: '全教科対応', price: '1回 ¥500' },
              { name: '完全個別指導コース', target: '学年問わず', style: '完全個別指導', subjects: '全教科対応', price: '1回 ¥6,000' },
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-5">
                <h4 className="text-lg font-bold text-gray-800 mb-3">{item.name}</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">対象</span>
                    <span className="text-gray-800 font-medium">{item.target}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">指導形式</span>
                    <span className="text-gray-800 font-medium">{item.style}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">対応科目</span>
                    <span className="text-gray-800 font-medium">{item.subjects}</span>
                  </div>
                  <div className="flex justify-between border-t pt-2 mt-2">
                    <span className="text-gray-500">月謝（税込）</span>
                    <span className="text-teal-600 font-bold">{item.price}</span>
                  </div>
                </div>
              </div>
            ))}
            <div className="bg-gray-50 rounded-xl p-4 text-center">
              <p className="text-xs text-gray-600">
                ※入会金：¥10,000（税込）
              </p>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 border-2 border-orange-200 rounded-2xl p-6 md:p-8 text-center">
          <h4 className="text-xl md:text-2xl font-bold text-gray-800 mb-3">
            部活との両立も可能
          </h4>
          <p className="text-sm md:text-base text-gray-700 leading-relaxed">
            授業時間は部活のスケジュールに合わせて調整可能。<br />
            <strong>学習習慣</strong>を身につけながら、無理なく続けられます。
          </p>
        </div>
      </div>
    </section>
  );
}